import { render, staticRenderFns } from "./v5.vue?vue&type=template&id=4e00a954&scoped=true&"
import script from "./v5.vue?vue&type=script&lang=js&"
export * from "./v5.vue?vue&type=script&lang=js&"
import style0 from "./v5.vue?vue&type=style&index=0&id=4e00a954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e00a954",
  null
  
)

export default component.exports